<template>
  <div class="form-group">
    <label class="tb-label layer-name">{{element.name}}</label>

    <!-- eslint-disable vue/no-v-model-argument -->
    <qr-code-url
      v-model:url="permalink"
      v-model:short-url="shortLink"
      v-model:tracking-link-rid="trackingLinkRid"
      v-model:tracking-link-metadata-rid="trackingLinkMetadataRid"
      :provider="!!provider"
      :item="this.graphic"
      :element="this.element"
      :entity-id="this.graphic.template_id"
      :data-test="`graphics-editor-${this.element.id}-permalink`"
    />
    <!-- eslint-enable vue/no-v-model-argument -->

    <div class="tb-form-group mt-4 flex items-center" data-entity="producer-editor-toggleBackgroundColorPicker" data-test="graphics-editor-qrCode-backgroundColor">
      <label class="tb-label mb-0 mr-2 flex-grow">Background color</label>

      <colorpicker
        :color="element.backgroundColor"
        :large="true"
        show-buttons
        @change="$emit('value', { value: $event, field: 'backgroundColor'} )"
      />
    </div>

    <div class="tb-form-group flex items-center" data-entity="producer-editor-toggleDotColorPicker" data-test="graphics-editor-qrCode-dotColor">
      <label class="tb-label mb-0 mr-2 flex-grow">Dot color</label>

      <colorpicker
        :color="element.dotColor"
        :large="true"
        show-buttons
        @change="$emit('value', { value: $event, field: 'dotColor'} )"
      />
    </div>

    <div class="tb-form-group">
      <div class="tb-checkbox">
        <input
          type="checkbox"
          id="hasLogo"
          v-model="hasLogo"
          data-entity="producer-editor-toggleImageLogo"
          data-test="graphics-editor-qrCode-logo"
          @change="$emit('value', { value: $event.target.checked, field: 'hasLogo'} )"
        />

        <label for="hasLogo">Show image logo</label>
      </div>
    </div>

    <template v-if="hasLogo">
      <div class="tb-form-group">
        <div v-if="logoUrl" class="media-upload-wrapper">
          <div class="media" :style="{ 'background-image' : 'url(' + logoPreviewUrl + ')' }"></div>
          <div class="edit-media">
            <button
              class="tb-btn tb-btn-contained on-image"
              data-entity="producer-editor-editLogo"
              data-test="graphics-editor-qrCode-logoSelect"
              @click="selectAsset"
            >
              <span class="fas fa-pencil-alt" />
            </button>
          </div>
        </div>

        <button
          v-else
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-editor-selectLogo"
              data-test="graphics-editor-qrCode-logoSelect"
          @click="selectAsset"
        >
          <span class="fas fa-image mr-1"></span>
          Choose image
        </button>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import getResizedImageUrl from '@/js/utils/imageUrl';
import QrCodeUrl from '../../../../shared/QrCodeUrl.vue';

export default {
  props: ['graphic', 'element', 'graphic_fields'],

  components: {
    QrCodeUrl,
  },

  computed: {
    logoPreviewUrl() {
      // Use the override-aware logo URL so the preview matches what renders.
      return getResizedImageUrl(this.logoUrl, 'w', 330);
    },

    computedFields() {
      return (
        this.graphic.fields?.[this.element.id]
        || this.graphic_fields?.[this.element.id]
      ) ?? {};
    },
    hasLogo: {
      get() {
        return this.computedFields.hasLogo ?? this.element.hasLogo;
      },

      set(v) {
        this.$emit('value', { value: v, field: 'hasLogo' });
      },
    },

    logoUrl() {
      return this.computedFields.logoUrl ?? this.element.logoUrl;
    },

    permalink: {
      get() {
        return this.computedFields.permalink ?? this.element.permalink;
      },

      set(v) {
        this.$emit('value', { value: v.trim(), field: 'permalink' });
      },
    },

    shortLink: {
      get() {
        return this.computedFields.shortLink ?? this.element.shortLink ?? '';
      },
      set(value) {
        this.$emit('value', { value, field: 'shortLink' });
      },
    },

    trackingLinkRid: {
      get() {
        return this.computedFields.trackingLinkRid ?? this.element.trackingLinkRid ?? '';
      },
      set(value) {
        // The numeric id belongs to the previous link. Clear it when the rid
        // changes so metadata sync resolves the new link from its rid instead
        // of pairing the fresh rid with a stale link id.
        if (value !== this.trackingLinkRid) {
          this.$emit('value', { value: null, field: 'trackingLinkId' });
        }

        this.$emit('value', { value, field: 'trackingLinkRid' });
      },
    },

    trackingLinkMetadataRid: {
      get() {
        return this.computedFields.trackingLinkMetadataRid ?? this.element.trackingLinkMetadataRid ?? '';
      },
      set(value) {
        this.$emit('value', { value, field: 'trackingLinkMetadataRid' });
      },
    },

    provider() {
      return this.element?.data?.provider;
    },
  },

  methods: {
    selectAsset() {
      this.$store.dispatch('toggleAssetModal', { toggled: true, type: 'image' });

      window.assetmanfn = (asset, meta = {}) => {
        this.element.logoUrl = asset.media_url;
        this.element.logoMeta = meta;
        this.$emit('value', { value: asset.media_url, field: 'logoUrl' });
        this.$emit('value', { value: meta, field: 'logoMeta' });
        this.$store.dispatch('toggleAssetModal', { toggled: false, type: 'image' });
      };
    },
  },
};
</script>
